import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import ITestRepository from '../../2_domain/test/iTestRepository';
import { TestStatusDto, TestCountResult } from '../../2_domain/test/test';
import Get from '../../lib/di/get';
import { toKRString } from '../../lib/util/dateFormatter';
import promiseResolver from '../../lib/util/promiseResolver';

const useProgressTestBoardController = (
  fromDate: Date | undefined,
  endDate: Date | undefined,
  statusOthers: TestStatusDto[]
) => {
  const testRepo = Get.find<ITestRepository>('ITestRepository');

  const navigate = useNavigate();
  const [notCompletedTest, setNotCompletedTest] = useState<TestCountResult[]>(
    []
  );
  const [totalCount, setTotalCount] = useState(0);
  const [loading, setLoading] = useState(false);

  const navigateToStatus = (str: TestStatus) => () =>
    navigate(
      `../test/check?status=${encodeURIComponent(str)}${
        fromDate ? `&from=${toKRString(fromDate)}` : ''
      }${endDate ? `&end=${toKRString(endDate)}` : ''}`
    );

  const loadNotCompletedTest = () => {
    promiseResolver({
      promise: testRepo.getTestOngoingSummaries(
        statusOthers,
        fromDate,
        endDate
      ),
      successCallback: (data) => {
        setNotCompletedTest(data);
      },
      isLoadingCallback: setLoading,
    });
  };

  useEffect(() => {
    if (notCompletedTest) {
      const sum = notCompletedTest?.reduce((prev, curr) => {
        return prev + curr.totalElements;
      }, 0);
      setTotalCount(sum);
    }
  }, [notCompletedTest]);

  useEffect(() => {
    loadNotCompletedTest();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fromDate, endDate]);

  return {
    notCompletedTest,
    totalCount,
    loading,
    navigateToStatus,
  };
};

export default useProgressTestBoardController;
